import {BeneficiaryRefund} from 'domain/usecases';
import {ModalityEnum} from 'domain/usecases/private/refund/request-preview';
import {IFile} from '../../components/UploadRefundFiles/types';

const enum StepPreviewEnum {
	BENEFICIARY_DATA,
	SERVICE_TYPE,
	UPLOAD_DOCUMENTS,
	REVIEW,
}

const enum StepPreviewEnumV2 {
	BENEFICIARY_DATA,
	SERVICE_TYPE,
	PROCEDURES,
	RESULT,
}

type RequestPreviewData = {
	beneficiary: BeneficiaryRefund;
	modality: ModalityEnum;
	description: string;
	files: IFile[];
	protocol: string;
	protocolCode: string;
	requestCode: string;
	request: string;
	requestDate: string;
};

export {StepPreviewEnum, StepPreviewEnumV2};
export type {RequestPreviewData};
